import { httpResource } from '@angular/common/http';
import { computed, inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FFFeatureFlagsService } from '@bannerflow/feature-flags';
import { BrandSettingsResponse } from '@bannerflow/types.orchestration-generator';
import { StudioFeatureFlags } from '@studio/domain/feature-flags/studio.ff.types';
import { BrandService } from '../brand/brand.service';
import { EnvironmentService } from '../services/environment.service';
import { UserService } from '../user';

@Injectable({ providedIn: 'root' })
export class BrandSettingsService {
    private environment = inject(EnvironmentService);
    private brandService = inject(BrandService);
    private featureFlagService = inject(FFFeatureFlagsService);
    private isVideoBudgetEnabled = toSignal(
        this.featureFlagService.isEnabled$(StudioFeatureFlags.VideoBudgetEnabled),
        { initialValue: false }
    );
    private userService = inject(UserService);
    private isImpactVideos25MbEnabled = this.userService.hasPermissionSignal('ImpactVideos25Mb');
    private isImpactVideos10MbEnabled = this.userService.hasPermissionSignal('ImpactVideos10Mb');

    private isImpactVideoEnabled = computed(() => {
        return this.isImpactVideos25MbEnabled() || this.isImpactVideos10MbEnabled();
    });
    private brandId = toSignal(this.brandService.brandId$, { initialValue: '' });

    brandSettings = httpResource<BrandSettingsResponse>(() => {
        return this.brandId() && this.isVideoBudgetEnabled() && this.isImpactVideoEnabled()
            ? this.environment.origins.orchestrationGenerator + `/api/brandSettings/${this.brandId()}`
            : undefined;
    });
}
